<template>
  <div class="actions_container">
    <v-progress-linear v-if="isLoading || isSubmitting" active indeterminate />
    <template v-if="!isLoading">
      <div
        v-if="!actions.length"
        class="info_section"
        v-text="$t('utils.noAvailableAction')"
      />
      <div v-else>
        <div v-for="(action, index) in actions" :key="index">
          <v-checkbox
            :input-value="action.enable"
            :label="action.name"
            :disabled="isSubmitting"
            readonly
            @click="toggleStatusAction(action)"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  fetchOrganizationWorkflowStatusActions,
  postOrganizationWorkflowStatusAction,
  deleteOrganizationWorkflowStatusAction,
} from "@/modules/Admin/Services/workflow.service";
export default {
  name: "WorkflowStatusActions",
  props: {
    status: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      actions: [],
      isLoading: true,
      isSubmitting: false,
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.fetchStatusActions();
      this.isLoading = false;
    },
    async fetchStatusActions() {
      let page = 1;
      this.actions = [];
      while (page) {
        const res = await fetchOrganizationWorkflowStatusActions({
          organizationId: this.$route.params.organizationId,
          workflowId: this.$route.params.workflowId,
          statusId: this.status.id,
          page,
        });
        this.actions = [...this.actions, ...res.data.results];
        page = res.data.next;
      }
    },
    async toggleStatusAction(action) {
      this.isSubmitting = true;
      const enable = !action.enable;
      try {
        if (enable) {
          await postOrganizationWorkflowStatusAction({
            organizationId: this.$route.params.organizationId,
            workflowId: this.$route.params.workflowId,
            statusId: this.status.id,
            actionId: action.id,
          });
        } else {
          await deleteOrganizationWorkflowStatusAction({
            organizationId: this.$route.params.organizationId,
            workflowId: this.$route.params.workflowId,
            statusId: this.status.id,
            actionId: action.id,
          });
        }
        action.enable = enable;
        this.$store.dispatch("snackbar/active", {
          message: this.$t(
            enable
              ? "workflow.status.snackbar.success.actionAssignedSuccessfully"
              : "workflow.status.snackbar.success.actionUnAssignedSuccessfully"
          ),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t(
            "workflow.status.snackbar.error.errorAssigningAction"
          ),
          type: "ERROR",
        });
      }
      this.isSubmitting = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.actions_container {
  .info_section {
    text-align: center;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #707080;
  }
}
</style>
